<template>
  <v-card flat  >
    <v-text-field clearable
        v-model='searchString'
        box
        :persistent-hint="selectMultiple"
        :hint='selectedFormatted.name'
        :loading="icd10SearchRequest.loading"
        :label="$t('search.label')" >
    </v-text-field>
    <v-card-text class='pt-0'>
      <v-layout wrap>
        <v-flex xs12 sm9 >
          <v-layout>
            <v-flex xs6 sm6>
              <v-switch
                v-model='selectMultiple'
                :label = '$t("inputs.multipleswitch.label")'
                :hint='$t("inputs.multipleswitch.hint")' persistent-hint >
              </v-switch>
            </v-flex>
            <v-flex xs6 sm6>
              <v-switch
                v-model='filtermit'
                :label = '$t("inputs.mit.label")'
                :hint='$t("inputs.mit.hint")' persistent-hint >
              </v-switch>
            </v-flex>
          </v-layout>
          <div v-if='selectMultiple && multiselected && multiselected.length > 0' class='mt-1' >
            <strong>Selected:</strong>
            <v-chip
              v-for='(item, index) in multiselected'
              @click='searchString = item.name'
              @input='multiselected.splice(index, 1)'
              :key='`${index}-${item.name}`'
              small label close
              color='primary' dark >{{item.name}}</v-chip>
          </div>
        </v-flex>
        <v-flex
          v-if='selectMultiple'
          xs12 sm3 class="text-xs-right" >
          <v-btn class='mt-4'
            @click='$emit("input", selectedFormatted); this.multiselected = []'
            :disabled="!multiselected || multiselected.length === 0"
            small color='primary' >
            Select
          </v-btn>
        </v-flex>
      </v-layout>
      <div>
        <v-subheader
          v-if='filteredSuggestions && filteredSuggestions.length > 0'
          class='pl-0 overline' >{{ $t('search.recent') }}</v-subheader>
        <v-chip  small label
          v-for='(code, index) in filteredSuggestions'
          @click='selectItem({name: code})'
          :key='`${index}-${code}`' >{{code}}</v-chip>
      </div>
    </v-card-text>
    <v-list v-if='searchString && searchString.length > 0' dense >
      <v-subheader class="overline" ><v-icon class='mr-1' small >search</v-icon>  Results</v-subheader>
      <v-divider></v-divider>
      <template v-for='result in searchResults' >
        <v-list-tile @click='selectItem(result)' :key='`li-${result.name}`' >
          <v-list-tile-action>{{result.name}}</v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{result.name}}
              <!-- <template class='ml-2'
                v-if='result.code_pack_facets' >
                <v-chip dark class='v-chip--x-small' color='primary'
                  v-for='facet in result.code_pack_facets'
                  :key='facet' >{{facet}}</v-chip>
              </template> -->
            </v-list-tile-title>
            <v-list-tile-sub-title>{{result.description}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if='result.code_pack_facets && result.code_pack_facets.length === 1' >
            <v-chip dark class='v-chip--x-small' color='primary'
                v-for='facet in result.code_pack_facets'
                :key='facet' >{{facet}}</v-chip>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key='`div-${result.name}`' ></v-divider>
      </template>
      <v-list-tile v-if='searchResults.length === 0'>
        <v-list-tile-content>{{ $t('search.noresults') }}</v-list-tile-content>
      </v-list-tile>
    </v-list>

  </v-card>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'IcdPicker',
  props: {
    value: { type: Object, default: null },
    touch: { type: Number, default: 0 },
    initialSearchString: { type: String, default: null },
    maxSuggestions: { type: Number, default: 15 },
    withSuggestions: { type: Boolean, default: true }
  },
  data () {
    return {
      selected: null,
      multiselected: [],
      selectMultiple: false,
      filtermit: true,
      limit: 10,
      searchReqId: 'icd10-search-request',
      suggestionsReqId: 'suggestionsReqId',
      searchString: null
    }
  },
  mounted () {
    this.search()
    if (this.suggestions && this.suggestions.length === 0) {
      this.getSuggestions()
    }
  },
  methods: {
    selectItem (item) {
      this.selected = item
      if (!item.name) { return }

      if (!this.selectMultiple) {
        this.$emit('input', item)
      } else {
        let exists = this.multiselected.find((codeItem) => {
          return codeItem.name === item.name
        })
        if (!exists) {
          this.multiselected.push(item)
          this.searchString = item.name
        }
      }
    },
    getSuggestions: debounce(
      function () {
        this.$appointmentguru
          .resource('appointment.codes.suggestions')
          .id(this.suggestionsReqId)
          .list()
      }
    ),
    reset () {
      this.multiselected = []
      this.searchString = ''
      this.selected = null
    },
    search: debounce(
      function () {
        if (this.searchString && this.searchString.length > 0) {
          let params = {
            search: this.searchString
          }
          if (this.filtermit) { params['codepacks'] = 1 }
          this.$codeguru
            .resource('code')
            .id(this.searchReqId)
            .list(params)
        }
      }, 500)
  },
  watch: {
    filtermit () {
      this.search()
    },
    searchString () {
      this.search()
    },
    initialSearchString () {
      this.searchString = this.initialSearchString
    },
    touch () {
      this.reset()
    }
  },
  computed: {
    suggestions () {
      if (this.suggestionsRequest &&
          this.suggestionsRequest.result &&
          this.suggestionsRequest.result.data &&
          this.suggestionsRequest.result.data.codes) {
        return this.suggestionsRequest.result.data.codes
      }
      return []
    },
    filteredSuggestions () {
      let hasSearchCriteria = (this.searchString && this.searchString.length > 0)
      let results = this.suggestions.icd10
      if (!results) { return [] }
      if (hasSearchCriteria) {
        results = results.filter((item) => {
          if (item && item.startsWith(this.searchString)) {
            return item
          }
        })
      }
      if (this.maxSuggestions !== 0) {
        return results.slice(0, this.maxSuggestions)
      }
      return results
    },
    searchResults () {
      if (this.icd10SearchRequest &&
          this.icd10SearchRequest.result &&
          this.icd10SearchRequest.result.data &&
          this.icd10SearchRequest.result.data.results) {
        return this.icd10SearchRequest.result.data.results.slice(0, this.limit)
      }
      return []
    },
    suggestionsRequest () {
      return this.$store.getters.getRequestById(this.suggestionsReqId, true)
    },
    icd10SearchRequest () {
      return this.$store.getters.getRequestById(this.searchReqId, true)
    },
    selectedFormatted () {
      if (this.multiselected && this.multiselected.length > 0) {
        let commaSeperated = this.multiselected.map((item) => {
          if (item.name) { return item.name }
        })
        if (commaSeperated && commaSeperated.length > 0) {
          return { name: commaSeperated.join(' / ') }
        }
      }
      return { name: '' }
    }
  },
  i18n: {
    messages: {
      en: {
        search: {
          recent: 'Recently used',
          label: 'Search for an ICD10 code',
          noresults: 'No codes matched your query'
        },
        inputs: {
          mit: {
            label: 'MIT Only',
            hint: 'Only include results from the Master Industry Table dictionary of codes (South Africa)'
          },
          multipleswitch: {
            label: 'Multiple codes',
            hint: 'Allows you to pick a number of ICD10 codes at once'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// IcdPicker.vue?9e2bbf92